import { IconX } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useRef, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { toast } from 'sonner';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import CreateAgent from '../../Agents/Components/CreateAgent';
import { accessCheck } from '../../../utils/accessCheck';
import { accessKeys } from '../../../statics/accessKeys';

const LinkAgentToInfluencerModal = ({ buttonComponent, influencerData }) => {
    const [show, setShow] = useState(false);
    const [agentList, setAgentList] = useState([]);
    const [loadingState, setLoadingState] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [showCreateButton, setShowCreateButton] = useState(false);
    const closeBtnRef = useRef(null);

    const handleClose = () => { setAgentList([]); setShowCreateButton(false); setShow(false) };
    const handleShow = () => setShow(true);

    const searchAgent = async (e) => {
        if (e.target.value.length >= 3) {
            setShowCreateButton(true);
            setLoadingState(true);
            let resp = await getApi(`${urlApi.searchAgent}?search=${e.target.value}`);
            setLoadingState(false);
            if (resp?.responseCode === 200) {
                setAgentList(resp.data);
            } else {
                setAgentList([]);
            }
        } else {
            toast.warning("Type minimum of 3 letters!")
            setAgentList([]);
        }
    }

    function onAgentSelect(agentData) {
        setSelectedAgent(agentData);
        setAgentList(null)
        document.getElementById('agentName').value = agentData.name;
    }

    const add = async () => {
        loadingShow();
        let resp = await getApi(`${urlApi.linkAgentToInfluencer}${selectedAgent?._id}/${influencerData?._id}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Link an Agent To This Influencer ({influencerData?.channelName}).</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div>
                        <label htmlFor="name" className='text-sm font-semibold mb-1'>Select Agent</label>
                        <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='Agent Name / Mobile / Email' id='agentName' onChange={_debounce((e) => searchAgent(e), 600)} />
                    </div>
                    <div className="max-h-80 overflow-y-auto mb-6">
                        {
                            loadingState ? <div className='mt-2 flex justify-center w-full'> <Spinner /></div> : (agentList?.length > 0 &&
                                agentList?.map((item) => (
                                    <div key={item?._id} className='cursor-pointer hover:bg-gray-200 px-3 py-2 rounded-md text-sm flex items-center flex-wrap gap-2' onClick={() => onAgentSelect(item)}>
                                        <img src={item?.profilePic} alt="" className='h-7' />
                                        {item?.name} - {item?.phone} - {item?.email}
                                    </div>
                                )))
                        }
                    </div>
                    {(accessCheck(accessKeys.createAndEditInfluencer) && showCreateButton) && <div className='flex justify-center items-center gap-3'>
                        <p className='text-sm font-semibold text-[#273144]'>Can't find your Agent?</p>
                        <CreateAgent buttonComponent={<button className='primary-btn' >Create and Link</button>} influencerData={influencerData} callbackClose={closeBtnRef} />
                    </div>}
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' ref={closeBtnRef} onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => add()}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default LinkAgentToInfluencerModal